<template>
  
  <div class="text-center">
    <v-pagination v-model="paging.page" 
    :length="Math.ceil(paging.count/ paging.size)" 
    @input="next"
    :total-visible="7"
    ></v-pagination>
  </div>
</template>
<script>
export default {
  name: "Pagination",
  props: {
    paging: { type: Object, required: true}
  },
  computed: {
   
  },
  watch: {
   
  },
  methods: {
    next(page) {
      console.log('next ' + page)
      this.$emit('next',page);
    }
  },
  data() {
    return {
       size:10
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Pagination.vue